import { render, staticRenderFns } from "./OnboardFlow.vue?vue&type=template&id=33d866c1&"
import script from "./OnboardFlow.vue?vue&type=script&lang=js&"
export * from "./OnboardFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports